import { render, staticRenderFns } from "./GroupRuns.vue?vue&type=template&id=0ff14302&scoped=true"
import script from "./GroupRuns.vue?vue&type=script&lang=ts"
export * from "./GroupRuns.vue?vue&type=script&lang=ts"
import style0 from "./GroupRuns.vue?vue&type=style&index=0&id=0ff14302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff14302",
  null
  
)

export default component.exports